import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=a20ccc08"
import script from "./InfoList.vue?vue&type=script&lang=js"
export * from "./InfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoItem: require('/app/components/InfoItem.vue').default})
